/* global KeyboardEvent */
// useEscapeKey — gọi onEscape khi nhấn Escape. Dùng cho các slide-in detail panel
// (vốn chỉ đóng bằng backdrop/X); modal đã tự xử lý Escape riêng. SSR-safe.

import { useEffect } from "react";

export function useEscapeKey(onEscape: () => void, active = true): void {
  useEffect(() => {
    if (!active || typeof document === "undefined") return;
    const handle = (e: KeyboardEvent) => {
      if (e.key === "Escape") onEscape();
    };
    document.addEventListener("keydown", handle);
    return () => document.removeEventListener("keydown", handle);
  }, [onEscape, active]);
}
